import { actions } from './data'

// Feed
export function fetch(locale) {
    return actions.feed.fetch(locale)
}

export function fetched(locale, ads) {
    return actions.feed.fetched(locale, ads)
}

export function fetching(locale) {
    return actions.feed.fetching(locale)
}

export function languageChanged(locale) {
    return actions.feed.languageChanged(locale)
}

export function outdated() {
    return actions.feed.outdated()
}

export function steamChanged(steamStartup) {
    return actions.feed.steamChanged(steamStartup)
}



// WEBPACK FOOTER //
// ./src/features/Ads/actions.js